export const warningMessages = {
    EmailUpdatedButNeedsRefresh: 'E-mailadres gewijzigd. Herladen niet gelukt, probeer opnieuw in te loggen.',
    InvalidLink: 'De link is ongeldig',
    LinkExpired: 'De link is verlopen, vraag een nieuwe link aan om het opnieuw te proberen.',
    LinkAlreadyUsed: 'De link is al gebruikt'
};
